import styled from "styled-components";

export default styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  h3 {
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    color: ${({ theme: { colors } }) => colors.ellipse_2};
  }
`;
